import React from 'react';
import Alert from '@material-ui/lab/Alert';

export const InvalidTaxForm = (): JSX.Element => (
    <Alert severity={'error'}>
        You have not filled out your tax form, please do so before claiming a payout.
    </Alert>
);
